module.exports = __webpack_public_path__ + "static/media/Метод_Монтессори__что_это_такое_.9a9f78f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/Метод_Монтессори__что_это_такое_.mp4
// module id = UYmr
// module chunks = 1